import React, { memo } from 'react';
import { AnimatePresence } from 'framer-motion';
import FeatureCard from './FeatureCard';
import FeatureCardSkeleton from './FeatureCardSkeleton';
import { TabContentProps } from './types';
import styles from './TabContent.module.css';

/**
 * CoreClassTab - Displays core class features and multiclass class features
 * Optimized with React.memo to prevent unnecessary re-renders
 */
const CoreClassTab: React.FC<TabContentProps> = memo(({
  features,
  expandedFeatures,
  onToggleExpand,
  isLoading = false
}) => {
  if (isLoading && features.length === 0) {
    return (
      <div className={styles.tabContent}>
        <FeatureCardSkeleton count={1} />
      </div>
    );
  }

  if (features.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No core class features available.</p>
      </div>
    );
  }

  return (
    <div className={styles.tabContent}>
      <AnimatePresence mode="popLayout">
        {features.map((feature) => (
          <FeatureCard
            key={feature.id}
            feature={feature}
            isExpanded={expandedFeatures.has(feature.id)}
            onToggleExpand={() => onToggleExpand(feature.id)}
          />
        ))}
      </AnimatePresence>
    </div>
  );
});

CoreClassTab.displayName = 'CoreClassTab';

export default CoreClassTab;
